<template>
  <div class="main">
    <div class="header">
      <img src="@/assets/imgs/logo-qinlian.png" alt="" class="logo" />
      <img src="@/assets/imgs/mrightbtn.png"  @click="drawer = true" alt="" class="logo-btn-img">
      <!-- <ul class="menu">
        <li class="m-item" :class="{ active: $route.path == item.path }" v-for="(item, key) in list" :key="key" @click="goView(item)">{{ item.title }}</li>
      </ul> -->
      <!-- 侧边栏 -->
      <!-- <el-drawer
        title="我是标题"
        :visible.sync="drawer"
        :direction="direction"
        :with-header="false"
        :before-close="handleClose">
        <p class="con"><router-link :to="'/contactUs'">联系我们</router-link></p>
        <p class="log"><router-link :to="'/login'">后台登录</router-link></p>
      </el-drawer> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'MyHeader',
  data() {
    return {
      drawer: false,
        direction: 'rtl',
      list: [
        {
          title: '首页',
          path: '/main'
        },
        // {
        //   title: '臻品服务',
        //   path: '/service'
        // },
        // {
        //   title: '区块链浏览器',
        //   path: ''
        // },
        // {
        //   title: '账户注册',
        //   path: '/register'
        // },
        {
          title: '联系我们',
          path: '/contactUs'
        },
        {
          title: '后台登录',
          path: '/login'
        }

      ]
    }
  },
  methods: {
     handleClose(done) {
       done();
        // this.$confirm('确认关闭？')
        //   .then(_ => {
        //     done();
        //   })
        //   .catch(_ => {});
      },
    
    goView(item) {
      if (item.title == "区块链浏览器") {
        window.open('https://devplatform.cetcxl.com/#/blockBrowser')
        return;
      }
      this.$router.push({ path: item.path })
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.main {
  width: 100%;
  height: 72px;
  line-height: 72px;
  // display:flex;
  // align-items: center;
  // border-bottom: 1px solid #0083D5;
  .header {
    display: flex;
    justify-content: space-between;
    .logo {
      width: 150px;
      height: 50px;
      margin-left: 20px;
      margin-top: 10px;
    }
    .logo-btn-img{
      width: 30px;
      height: 30px;
      margin-right: 20px;
      margin-top: 22px;
      // cursor: pointer;
    }
    .con:hover{
      background:GhostWhite;
    }
    .log:hover{
      background:GhostWhite;

    }
    
  }
}
</style>
